<template>
   <div class="report">
      <Delete :delete_message="delete_message" :show="show_delete_modal" @close="$store.commit('show_delete_modal',false)" @delete="deleteReport()"/>

      <Modal :show="show_create_modal" content_class="col-12 col-md-7 col-lg-6 col-xl-5" @close="$store.commit('show_create_modal',false)">
         <template slot="title">
            <div class="title">{{Model.forms.addReport.title}}</div>
            <div class="subtitle">{{Model.forms.addReport.subtitle}}</div>
         </template>
         <template slot="content">
            <div>
               <Form 
                  class_binding="row" 
                  :ref="Model.forms.addReport.name" 
                  :forms="Model.forms.addReport.forms" 
                  :form_data="Model.forms.addReport.data"
               />
               <div class="btns clearfix">
                  <div class="btn btn-primary btn-r" @click="addReport({ref: $refs[Model.forms.addReport.name]})" :disabled="loading">
                     Create <div class="lds-ring" v-show="loading"><div></div><div></div><div></div><div></div></div>
                  </div>
               </div>
            </div>
         </template>
      </Modal>

      <Modal :show="show_edit_modal" content_class="col-12 col-md-7 col-lg-6 col-xl-5" @close="$store.commit('show_edit_modal',false)">
         <template slot="title">
            <div class="title">{{Model.forms.editReport.title}}</div>
            <div class="subtitle">{{Model.forms.editReport.subtitle}}</div>
         </template>
         <template slot="content">
            <div>
               <Form 
                  class_binding="row" 
                  :ref="Model.forms.editReport.name" 
                  :forms="Model.forms.editReport.forms" 
                  :form_data="Model.forms.editReport.data"
               />
               <div class="btns clearfix">
                  <div class="btn btn-primary btn-r" @click="updateReport({ref: $refs[Model.forms.editReport.name]})" :disabled="loading">
                     Save <div class="lds-ring" v-show="loading"><div></div><div></div><div></div><div></div></div>
                  </div>
               </div>
            </div>
         </template>
      </Modal>

      <Modal :show="show_send_report" content_class="col-12 col-md-7 col-lg-6 col-xl-5" @close="$store.commit('show_send_report',false)">
         <template slot="title">
            <div class="title">{{Model.forms.sendReport.title}}</div>
            <div class="subtitle">{{Model.forms.sendReport.subtitle}}</div>
         </template>
         <template slot="content">
            <div>
               <Form 
                  class_binding="row" 
                  :ref="Model.forms.sendReport.name" 
                  :forms="Model.forms.sendReport.forms" 
                  :form_data="Model.forms.sendReport.data"
               />
               <div class="btns clearfix">
                  <div class="btn btn-primary btn-r" @click="sendReport({ref: $refs[Model.forms.sendReport.name]})" :disabled="loading">
                     Save <div class="lds-ring" v-show="loading"><div></div><div></div><div></div><div></div></div>
                  </div>
               </div>
            </div>
         </template>
      </Modal>

      <div class="top-actions clearfix">
         <div class="btn btn-primary btn-r" @click="$store.commit('show_create_modal',true)">
            Add Report <i class="fa fa-plus"></i>
         </div>
      </div>
      
      <Table v-bind="Model.tables.report.props" :data="reports" @on-action="handleActions"/>
   </div>
</template>

<script>
import report from "./report.store";

export default {
   beforeDestroy () {
      this.$store.unregisterModule('report')
   },
   created(){
      Event.$emit('loader:show',true)
      utils.registerModule('report',report,this.$store)
   },
   components:{
      Delete: () => import("wino-template/components/delete"),
      Modal: () => import("wino-template/components/modal"),
      Form: () => import("clarks/components/form"),
      Table: () => import("clarks/components/ivu-table"),
   },
   computed: {
      ...mapGetters([
         'Model',
         'reports',
         'show_create_modal',
         'show_edit_modal',
         'show_send_report',
         'show_delete_modal',
         'loading',
         'delete_message',
      ])
   },
   methods: {
      ...mapActions([
         'fetchData',
         'addReport',
         'deleteReport',
         'updateReport',
         'sendReport',
         'handleActions',
      ]),
   },
   async mounted(){
      utils.registerModule('report',report,this.$store)
      await this.fetchData()
   }
}
</script>

<style lang="scss">
   .report{
      
   }
</style>